const LS_KEY = "comfyviz_theme";

export type Theme = "dark" | "light";

let listeners: Array<() => void> = [];
let current: Theme = (localStorage.getItem(LS_KEY) as Theme) || "dark";

// Apply on module load so the DOM is correct before first render
document.documentElement.setAttribute("data-theme", current);

export function getTheme(): Theme {
  return current;
}

export function setTheme(t: Theme): void {
  if (t === current) return;
  current = t;
  localStorage.setItem(LS_KEY, t);
  document.documentElement.setAttribute("data-theme", t);
  for (const fn of listeners) fn();
}

export function toggleTheme(): void {
  setTheme(current === "dark" ? "light" : "dark");
}

/** Subscribe to theme changes — returns unsubscribe function. */
export function subscribe(fn: () => void): () => void {
  listeners.push(fn);
  return () => {
    listeners = listeners.filter((l) => l !== fn);
  };
}
